export default __webpack_public_path__ + "static/char-s-48-ko-256f67402249526899cc44dcf5ccd2b8.webp";